import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { Info } from '@mui/icons-material';

const CompanyAndRoleTable = ({
  rows,
  handleEditClick,
  HandleRemoveClick,
  handlePricingGeographyEditClick,
}) => {
  return (
    <>
      {rows && rows.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Manufacture Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Pricing Geography</TableCell>
                <TableCell align='right'>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    background:
                      row?.requested_dealership_firm_details && '#f5f5f5',
                  }}
                >
                  <TableCell sx={{ border: 'none' }}>
                    {row.active_dealership_firm_details?.manufacturer_name ||
                      row.requested_dealership_firm_details?.manufacturer_name}
                    {row?.requested_dealership_firm_details && (
                      <Tooltip
                        title={`Requested role for ${row?.requested_dealership_firm_details?.region_role_name} has been sent for approval`}
                      >
                        <IconButton color='primary'>
                          <Info />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell sx={{ border: 'none' }}>
                    {row.active_dealership_firm_details?.region_role_name ||
                      row.requested_dealership_firm_details
                        ?.region_role_name}{' '}
                    <Tooltip title={'Edit Company'}>
                      <IconButton
                        color='primary'
                        onClick={() => handleEditClick(row)}
                        disabled={row?.requested_dealership_firm_details}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell sx={{ border: 'none' }}>
                    {row.active_dealership_firm_details
                      ?.manufacturer_pricing_geography_name ||
                      row.requested_dealership_firm_details
                        ?.manufacturer_pricing_geography_name}{' '}
                    <Tooltip title={'Edit Pricing Geography'}>
                      <IconButton
                        color='primary'
                        onClick={() => handlePricingGeographyEditClick(row)}
                        disabled={row?.requested_dealership_firm_details}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{ border: 'none' }}
                    align='right'
                  >
                    <Tooltip title='Remove Company'>
                      <IconButton
                        color='primary'
                        onClick={() => HandleRemoveClick(row)}
                        disabled={row?.requested_dealership_firm_details}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default CompanyAndRoleTable;
